import React, { useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import {TitleWiseDashboard,pcrReportBasic,pcrComments} from '../../../../app/models/Restoration'
import moment from 'moment';
import { useStore } from '../../../../app/stores/store';
import { toast } from 'react-toastify';
import { Header, Table, TableBody, TableCell,TableRow,Image,Dropdown, Input, Button, TableHeader, TableHeaderCell, Icon, Modal, ModalHeader, ModalDescription } from 'semantic-ui-react';
import PCRDownload from '../PCRReport/PCRPdfDownload';

const styles={
  'pcr-report-value': {
    borderRight: '1px solid gray',
    textAlign: 'right',},
  dropdown: {
    border: 'none',textAlign:'right' }
}
interface PCRPDFComponentProps {
  rowdata: TitleWiseDashboard;
}
interface pcrComment {
  S_No: number;
  Int_Ext: string;
  Description: string;
  Action_taken: string;
}
function PCRReport({ rowdata }: PCRPDFComponentProps) {
  const { RestorationStore } = useStore();
  const pdfRef=useRef(null);
  const currentDate = new Date();
  const [loadData, setLoadData] = useState<pcrReportBasic|null>(null);
  const [pcrLoadComment,setPcrLoadComment]=useState<pcrComments[]>([]);
  const [deliveryDate, setDeliveryDate] = useState(() => moment(currentDate).startOf('month').format('DD-MMMM-YYYY'));
  const [tableData, setTableData] = useState([{ S_No: 1,indexNumber:0,Int_Ext: '', Description: '',Action_taken:'' },]);
  const [level,setlevel]=useState<string>('');
  const [lOBSplitup,setlOBSplitup]=useState<string>('');
  const [outputMaterial,setoutputMaterial]=useState<string>('');
  const [inputMaterial,setinputMaterial]=useState<string>('');
  const [workadvice,setWorkAdvice]=useState<string>('Y');
  const [contractReview,setcontractReview]=useState<string>('Y');
  const [analysisReport,setanalysisReport]=useState<string>('Y');
  const [qAFeedbackTracker,setqAFeedbackTracker]=useState<string>('Y');
  const [estimationtoClient,setestimationtoClient]=useState<string>('Y');
  const [contentReport,setcontentReport]=useState<string>('Y');
  const [shotEstimateReport,setshotEstimateReport]=useState<string>('Y');
  const [projectallocationSheet,setprojectallocationSheet]=useState<string>('Y');
  const [dailyTracker,setdailyTracker]=useState<string>('Y');
  const [estimationReport,setestimationReport]=useState<string>('Y');
  const [finalRestorationReport,setfinalRestorationReport]=useState<string>('Y');
  const [lTOLog,setlTOLog]=useState<string>('Y');
  const [deletionApprovalrecd,setdeletionApprovalrecd]=useState<string>('Y');
  const [projectBrief,setprojectBrief]=useState<string>('Y');
  const [qCFeedbackTracker,setqCFeedbackTracker]=useState<string>('Y');
  const [projectPlanandTracker,setprojectPlanandTracker]=useState<string>('Y');
  const[iomNos,setIomNos]=useState<string>('');
  const[omNos,setOmNos]=useState<string>('');
  const[ourOMNos,setourOMNos]=useState<string>('');
  const[noofReworkHrs,setnoofReworkHrs]=useState<string>('');
  const[customerComplaints,setcustomerComplaints]=useState<string>('');
  const[dREQC,setdREQC]=useState<string>('');
  const[dREClient,setdREClient]=useState<string>('');
  const[note,setnote]=useState<string>('');
  const[improvementData,setimprovementData]=useState<string>('');
  const [open, setOpen] = useState(false);
  const[openPCRReport,setOpenPCRReport]= useState(false);
  const [confirmModelOpen,SetconfirmModelOpen]= useState(false);
  const goBack = () => {
    window.location.reload();
};

  const handleAddRow = () => { const newRow={
      S_No: tableData.length + 1,
      indexNumber:tableData.length + 1,
      Int_Ext: '',
      Description: '',
      Action_taken: '',
    }
    setTableData([...tableData, newRow]);
  };
  const handleRemoveRow = (rowIndexToRemove: number) => {
    const updatedData = tableData.filter((row, index) => index !== rowIndexToRemove);
    const resetSNoData = updatedData.map((row, index) => {
      return { ...row, S_No: index + 1 };
  });
    setTableData(resetSNoData);
  
};
const handleChange = (e: React.ChangeEvent<HTMLInputElement>, id: number, field: string) => {
  const updatedData = tableData.map(row => {
    if (row.S_No === id) {
      return { ...row, [field]: e.target.value };
    }return row;});
  setTableData(updatedData);
};
  const dropDownOption=[{ key: 1, text: 'Y', value: 'Y' },{ key: 1, text: 'N', value: 'N' }]
  const MaterialOption=[
    { key: 1, text: 'LTO', value: 'LTO' },
    { key: 2, text: 'HD', value: 'HD' },
    { key: 3, text: 'UPLOAD', value: 'UPLOAD' },
    { key: 4, text: 'DMD Transfer', value: 'DMD Transfer' },
    
  ]
  const levelOption=[
    { key: 1, text: 'Simple', value: 'Simple' },
    { key: 2, text: 'Medium', value: 'Medium' },
    { key: 3, text: 'Complex', value: 'Complex' },
  ]
  const ClientTypeOption=[
    { key: 1, text: 'International', value: 'International' },
    { key: 2, text: 'Domestic', value: 'Domestic' }  ]
    
  const setDate = (data: any, type: string) => {
    try {if (type === 'delivery') {
          setDeliveryDate(moment(data).format('DD-MMMM-YYYY'));} 
        } 
        catch (error) {toast.error('Error fetching Date');}};

        const dataApiLoad = async () => {
          try {
            await RestorationStore.PCRReportBasic(rowdata.title_Code);
            setLoadData(RestorationStore.pcrBasic);
          } catch (error) {
            toast.error('Error fetching PCRReportBasic');
          }
        };
        
        const dataCommentLoad = async () => {
          try {
            await RestorationStore.getPCRComments(rowdata.title_Code);
            setPcrLoadComment(RestorationStore.pcrCommentsDetails);
           
          } catch (error) {
            toast.error('Error fetching PCR comments');
          }
        };
        const Confirmation=async()=>{
          SetconfirmModelOpen(true);
      }
        const CreateCommentLoad = async (payLoad:pcrComment) => {
          try {
            const data={
              titleCode:rowdata.title_Code,
              int_Ext: payLoad.Int_Ext,
              description: payLoad.Description,
              action_Taken: payLoad.Action_taken,
            }
              await RestorationStore.createPCRComments(data);
          } catch (error) {
            toast.error('Error fetching PCR comments');
          }
        };
        
        const CreatePCRDetails=async()=>{
          try {
          const pcrdata={
                Titlecode: rowdata.title_Code,
                level:level,
                Input_Metrial: inputMaterial,
                OutPut_Metrial: outputMaterial,
                IM_Nos: iomNos,
                OM_Nos: omNos,
                Our_OM_Nos: ourOMNos,
                Lob_Split_up: lOBSplitup,
                Location_Split_up: "Chennai",
                Work_Advice: workadvice,
                Contract_Review: contractReview,
                Analysis_Report: analysisReport,
                QA_Feedback_Tracker: qAFeedbackTracker,
                Estimation_to_Client: estimationtoClient,
                Content_Report: contentReport,
                Shot_Estimate_Report: shotEstimateReport,
                Project_allocation_Sheet: projectallocationSheet,
                Daily_Tracker: dailyTracker,
                Estimation_Report: estimationReport,
                Final_Restoration_Report: finalRestorationReport,
                LTO_Log: lTOLog,
                Detection_Approval_reacd:deletionApprovalrecd ,
                Project_Brief: projectBrief,
                QC_Feedback_Tracker: qCFeedbackTracker,
                Project_Plan_and_Tracker: projectPlanandTracker,
                No_of_ReworkingHrs:noofReworkHrs,
                DRE_QC: dREQC,
                DRE_Client: dREClient,
                Customer_Complaints: customerComplaints,
                notes: note,
                actualDeliveryDate:deliveryDate,
                improvements:improvementData,
          };
          if(pcrdata!==null){
            await RestorationStore.createPCRdetails(pcrdata);
            setOpen(true);
            setOpenPCRReport(true);
          }

          }
          catch (error) {
            toast.error('Error fetching PCR comments');
          }
        }
        const updateCommentLoad = async (payLoad:pcrComment) => 
          {
            try {
              const data={
                titleCode:rowdata.title_Code,
                int_Ext: payLoad.Int_Ext,
                description: payLoad.Description,
                action_Taken: payLoad.Action_taken,
              }
                await RestorationStore.RemovePCRComment(data);
                toast.error('PCR Report Create Successfully');
               
            } catch (error) {
              toast.error('Error fetching PCR comments');
            }
        }
    useEffect(()=>{
              dataApiLoad();
              dataCommentLoad();
              // eslint-disable-next-line 
            },[])
    useEffect(()=>{

  if(pcrLoadComment !== null && pcrLoadComment.length>0)
    {
    setTableData(
      pcrLoadComment.map((comment, index) => ({
        S_No: index + 1,
        indexNumber: comment.indexNumber,
        Int_Ext: comment.int_Ext,
        Description: comment.description,
        Action_taken: comment.action_Taken,
      }))
    );
  }
},[pcrLoadComment])
  return (
    <>
    <div ref={pdfRef}>

          <Table className="ui unstackable table" style={{ border: '1px solid gray' }}>

              <TableBody>
                <TableRow>
                <TableCell style={{textAlign: 'center'}}><Image src={'../assets/PrasadCorp.jpg'} size='small' /></TableCell>
                  <TableCell colSpan={4} style={{textAlign: 'center'}}><Header as='h1'>RESTORATION </Header><Header as='h2'>Project Closure Document</Header></TableCell>
                  <TableCell style={{textAlign: 'center'}}></TableCell>
                </TableRow>
                <TableRow>
                <TableCell style={styles['pcr-report-value']}><Header as='h4'>PCR Number</Header></TableCell>
                <TableCell >{loadData!==null&&loadData.pcrNumber}</TableCell>
                <TableCell ></TableCell>
                <TableCell></TableCell>
                <TableCell style={styles['pcr-report-value']}><Header as='h4'>PCR Date</Header></TableCell>
                <TableCell >{loadData!==null&&loadData.pcrDate}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={6} style={{textAlign: 'center',backgroundColor: 'lightgray'}}> <Header as='h3'>Project Details (Enter relevant details) </Header></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><Header as='h4'>Client</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}>{loadData!== null && loadData.client}</TableCell>
                  <TableCell ><Header as='h4'>Input Material</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}>
                  <Dropdown
                      placeholder='Input Material'
                      search
                      selection
                      options={MaterialOption}
                      defaultValue={MaterialOption[0].value}
                      style={styles['dropdown']}
                      onChange={(event, data:any) => {
                        if (data.value !== undefined) {
                          setinputMaterial(data.value);
                        }
                      }}
                    />
                  </TableCell>
                  <TableCell><Header as='h4'>Start Date</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}>{rowdata.start_date}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><Header as='h4'>Project</Header></TableCell>
                  <TableCell style={{ borderRight: '1px solid gray' ,textAlign:'right' }}>{rowdata.title_Name}</TableCell>
                  <TableCell ><Header as='h4'>IM Nos.</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}><Input type="text" placeholder="" style={{ margin: 0, padding: 0 }} value={iomNos} onChange={(event) => setIomNos(event.target.value)}/></TableCell>
                  <TableCell><Header as='h4'>End Date</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}>{loadData!== null && loadData.end_Date}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><Header as='h4'>Level</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}>
                  <Dropdown
                    placeholder='Level'
                    search
                    selection
                    options={levelOption}
                    defaultValue={levelOption[0].value}
                    style={styles['dropdown']}
                    onChange={(event,data:any)=>{
                      if(data.value!==undefined){
                        setlevel(data.value)
                      }
                    }}
                  />  
                  </TableCell>
                  <TableCell><Header as='h4'>Output Material</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}>
                  <Dropdown
                    placeholder='Output Material'
                    search
                    selection
                    options={MaterialOption}
                    defaultValue={MaterialOption[0].value}
                    style={styles['dropdown']}
                    onChange={(event,data:any)=>{
                      if(data.value!==undefined){
                        setoutputMaterial(data.value)
                      }
                    }}
                  />
                  </TableCell>
                  <TableCell><Header as='h4'>Committed Del. Date</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}>{rowdata.delivery_date}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><Header as='h4'>Resolution</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}>{rowdata.resolution}</TableCell>
                  <TableCell><Header as='h4'>OM Nos.</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}><Input type="text" placeholder=""  style={{ margin: 0, padding: 0 }} value={omNos} onChange={(event) => setOmNos(event.target.value)}/></TableCell>
                  <TableCell><Header as='h4'>Actual Delivery Date</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}>
                  <DatePicker
                        placeholderText="Delivery Date"
                        selected={moment(deliveryDate, 'DD-MMMM-YYYY').toDate()}
                        className="date-picker-style"
                        onChange={(date) => setDate(date, 'delivery')}
                      />
                </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><Header as='h4'>Reels</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}>{loadData!== null && loadData.reels}</TableCell>
                  <TableCell><Header as='h4'>Our OM Nos.</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}><Input type="text" placeholder="" style={{ margin: 0, padding: 0 }} value={ourOMNos} onChange={(event) => setourOMNos(event.target.value)}/></TableCell>
                  <TableCell><Header as='h4'>Estimated Hours</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}>{rowdata.estimate_Hour}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><Header as='h4'>Shots</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}>{loadData!== null && loadData.shots}</TableCell>
                  <TableCell ><Header as='h4'>LOB Split up</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}>
                    <Dropdown
                    placeholder='LOB Split up'
                    search
                    selection
                    options={ClientTypeOption}
                    defaultValue={ClientTypeOption[0].value}
                    style={styles['dropdown']}
                    onChange={(event,data:any)=>{
                      if(data.value!==undefined){
                        setlOBSplitup(data.value);
                      }
                    }}
                  /></TableCell>
                  <TableCell><Header as='h4'>Actual Hours</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}>{rowdata.total_Hours}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><Header as='h4'>Frames</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}>{rowdata.allocated_Frames}</TableCell>
                  <TableCell><Header as='h4'>Location Split up</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}>{'CHENNAI'}</TableCell>
                  <TableCell><Header as='h4'>Cluster</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}>{loadData!== null && loadData.cluster}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={6} style={{textAlign: 'center',backgroundColor: 'lightgray'}}> <Header as='h3'>Project Checklist (Enter Yes or No) </Header></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ verticalAlign:'baseline' }}><Header as='h3'>Work Advice</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}>
                    <Dropdown
                    placeholder='Work Advice'
                    search
                    selection
                    options={dropDownOption}
                    defaultValue={dropDownOption[0].value}
                    style={styles['dropdown']}
                    onChange={(event,data:any)=>{
                      if(data.value!==undefined){
                        setWorkAdvice(data.value);
                      }
                    }}
                  />
                  </TableCell>
                  <TableCell><Header as='h4'>Shot Estimate Report</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}> <Dropdown
                    placeholder='Shot Estimate Report'
                    search
                    selection
                    options={dropDownOption}
                    defaultValue={dropDownOption[0].value}
                    style={styles['dropdown']}
                    onChange={(event,data:any)=>{
                      if(data.value!==undefined){
                        setshotEstimateReport(data.value);
                      }
                    }}
                  /></TableCell>
                  <TableCell><Header as='h4'>LTO Log</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}> 
                  <Dropdown
                    placeholder='LTO Log'
                    search
                    selection
                    options={dropDownOption}
                    defaultValue={dropDownOption[0].value}
                    style={styles['dropdown']}
                    onChange={(event,data:any)=>{
                      if(data.value!==undefined){
                        setlTOLog(data.value);
                      }
                    }}
                  /></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><Header as='h4'>Contract Review</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}> <Dropdown
                    placeholder='Contract Review'
                    search
                    selection
                    options={dropDownOption}
                    defaultValue={dropDownOption[0].value}
                    style={styles['dropdown']}
                    onChange={(event,data:any)=>{
                      if(data.value!==undefined){
                        setcontractReview(data.value);
                      }
                    }}
                  /></TableCell>
                  <TableCell><Header as='h4'>Project allocation Sheet</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}> <Dropdown
                    placeholder='Project allocation Sheet'
                    search
                    selection
                    options={dropDownOption}
                    defaultValue={dropDownOption[0].value}
                    style={styles['dropdown']}
                    onChange={(event,data:any)=>{
                      if(data.value!==undefined){
                        setprojectallocationSheet(data.value);
                      }
                    }}
                  /></TableCell>
                  <TableCell><Header as='h4'>Deletion Approval recd.</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}> <Dropdown
                    placeholder='Deletion Approval'
                    search
                    selection
                    options={dropDownOption}
                    defaultValue={dropDownOption[0].value}
                    style={styles['dropdown']}
                    onChange={(event,data:any)=>{
                      if(data.value!==undefined){
                        setdeletionApprovalrecd(data.value);
                      }
                    }}
                  /></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><Header as='h4'>Analysis Report</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}> <Dropdown
                    placeholder='Analysis Report'
                    search
                    selection
                    options={dropDownOption}
                    defaultValue={dropDownOption[0].value}
                    style={styles['dropdown']}
                    onChange={(event,data:any)=>{
                      if(data.value!==undefined){
                        setanalysisReport(data.value);
                      }
                    }}
                  /></TableCell>
                  <TableCell><Header as='h4'>Daily Tracker</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}> <Dropdown
                    placeholder='Daily Tracker'
                    search
                    selection
                    options={dropDownOption}
                    defaultValue={dropDownOption[0].value}
                    style={styles['dropdown']}
                    onChange={(event,data:any)=>{
                      if(data.value!==undefined){
                        setdailyTracker(data.value);
                      }
                    }}
                  /></TableCell>
                  <TableCell><Header as='h4'>Project Brief</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}> <Dropdown
                    placeholder='Project Brief'
                    search
                    selection
                    options={dropDownOption}
                    defaultValue={dropDownOption[0].value}
                    style={styles['dropdown']}
                    onChange={(event,data:any)=>{
                      if(data.value!==undefined){
                        setprojectBrief(data.value);
                      }
                    }}
                  /></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><Header as='h4'>QA Feedback Tracker</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}> <Dropdown
                    placeholder='QA Feedback'
                    search
                    selection
                    options={dropDownOption}
                    defaultValue={dropDownOption[0].value}
                    style={styles['dropdown']}
                    onChange={(event,data:any)=>{
                      if(data.value!==undefined){
                        setqAFeedbackTracker(data.value);
                      }
                    }}
                  /></TableCell>
                  <TableCell><Header as='h4'>Estimation Report</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}> <Dropdown
                    placeholder='Estimation Report'
                    search
                    selection
                    options={dropDownOption}
                    defaultValue={dropDownOption[0].value}
                    style={styles['dropdown']}
                    onChange={(event,data:any)=>{
                      if(data.value!==undefined){
                        setestimationReport(data.value);
                      }
                    }}
                  /></TableCell>
                  <TableCell><Header as='h4'>QC Feedback Tracker</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}> <Dropdown
                    placeholder='QC Feedback'
                    search
                    selection
                    options={dropDownOption}
                    defaultValue={dropDownOption[0].value}
                    style={styles['dropdown']}
                    onChange={(event,data:any)=>{
                      if(data.value!==undefined){
                        setqCFeedbackTracker(data.value);
                      }
                    }}
                  /></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><Header as='h4'>Estimation to Client</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}> <Dropdown
                    placeholder='Estimation'
                    search
                    selection
                    options={dropDownOption}
                    defaultValue={dropDownOption[0].value}
                    style={styles['dropdown']}
                    onChange={(event,data:any)=>{
                      if(data.value!==undefined){
                        setestimationtoClient(data.value);
                      }
                    }}
                  /></TableCell>
                  <TableCell><Header as='h4'>Final Restoration Report</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}> <Dropdown
                    placeholder='Final Restoration'
                    search
                    selection
                    options={dropDownOption}
                    defaultValue={dropDownOption[0].value}
                    style={styles['dropdown']}
                    onChange={(event,data:any)=>{
                      if(data.value!==undefined){
                        setfinalRestorationReport(data.value);
                      }
                    }}
                  /></TableCell>
                  <TableCell><Header as='h4'>Project Plan and Tracker</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}> 
                  <Dropdown
                    placeholder='Project Plan'
                    search
                    selection
                    options={dropDownOption}
                    defaultValue={dropDownOption[0].value}
                    style={styles['dropdown']}
                    onChange={(event,data:any)=>{
                      if(data.value!==undefined){
                        setprojectPlanandTracker(data.value);
                      }
                    }}
                  />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><Header as='h4'>Content Report</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}> <Dropdown
                    placeholder='Content Report'
                    search
                    selection
                    options={dropDownOption}
                    defaultValue={dropDownOption[0].value}
                    style={styles['dropdown']}
                    onChange={(event,data:any)=>{
                      if(data.value!==undefined){
                        setcontentReport(data.value);
                      }
                    }}
                  /></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={6} style={{textAlign: 'center',backgroundColor: 'lightgray'}}><Header as='h3'> Project Metrics (Enter relevant data and remarks)</Header> </TableCell>
                </TableRow>
                
                <TableRow>
                  <TableCell style={{borderRight: '1px solid gray' }}><Header as='h4'>Internal Frames Quality</Header></TableCell>
                  <TableCell style={{  textAlign: 'center',borderRight: '1px solid gray' }}><Header as='h4' >QC</Header></TableCell>
                  <TableCell style={{  textAlign: 'center',borderRight: '1px solid gray' }} ><Header as='h4'>FQA</Header></TableCell>
                  <TableCell><Header as='h4'>IMPROVEMENTS</Header></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{borderRight: '1px solid gray' }}><Header as='h4'>No. of Frames Rejected</Header></TableCell>
                  <TableCell style={{ textAlign: 'center', borderRight: '1px solid gray' }}>{loadData!== null && loadData.qcFrame}</TableCell>
                  <TableCell style={{  textAlign: 'center',borderRight: '1px solid gray' }}>{loadData!== null && loadData.fqaFrame}</TableCell>
                  <TableCell colSpan={3}><Input type="text" placeholder="Please Enter Improvement Points" style={{ width: '100%', margin: 0, padding: 0 }} value={improvementData} onChange={(event) => setimprovementData(event.target.value)}/></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><Header as='h4'>No. of Re-work Hrs</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}></TableCell>
                  <TableCell colSpan={3}><Input type="text" placeholder="Please Enter No. of Re-work Hrs" style={{ margin: 0, padding: 0 }} value={noofReworkHrs} onChange={(event) => setnoofReworkHrs(event.target.value)}/></TableCell>
                 
                </TableRow>
                <TableRow>
                  <TableCell><Header as='h4'>Customer Complaints</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}></TableCell>
                  <TableCell colSpan={4}><Input type="text" placeholder="Please Enter Customer Complaints" style={{ width: '100%', margin: 0, padding: 0 }} value={customerComplaints} onChange={(event) => setcustomerComplaints(event.target.value)}/></TableCell>
                  
                </TableRow>
                <TableRow>
                  <TableCell><Header as='h4'>DRE - QC</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}></TableCell>
                  <TableCell colSpan={4}><Input type="text" placeholder="Please Enter DRE - QC" style={{ width: '100%', margin: 0, padding: 0 }} value={dREQC} onChange={(event) => setdREQC(event.target.value)}/></TableCell>
                 
                </TableRow>
                <TableRow>
                  <TableCell><Header as='h4'>DRE - Client</Header></TableCell>
                  <TableCell style={styles['pcr-report-value']}></TableCell>
                  <TableCell colSpan={4}><Input type="text" placeholder="Please Enter DRE - Client" style={{ width: '100%', margin: 0, padding: 0 }} value={dREClient} onChange={(event) => setdREClient(event.target.value)}/></TableCell>
                  
                </TableRow>
                <TableRow>
                  <TableCell colSpan={6} style={{textAlign: 'center',backgroundColor: 'lightgray'}}><Header as='h3'>Comments </Header></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={6}>
                  <div>
                      <Table>
                        <TableHeader>
                          <TableRow>
                            <TableHeaderCell>S.No</TableHeaderCell>
                            <TableHeaderCell>Int / Ext</TableHeaderCell>
                            <TableHeaderCell>Description</TableHeaderCell>
                            <TableHeaderCell>Action taken</TableHeaderCell>
                            <TableHeaderCell></TableHeaderCell>
                            <TableHeaderCell>Action</TableHeaderCell>
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                        {tableData.map((row, index) => (
            <Table.Row key={index}>
              <Table.Cell>{row.S_No}</Table.Cell>
              <Table.Cell>
                <Input
                  type="text"
                  value={row.Int_Ext}
                  onChange={(e) => handleChange(e, row.S_No, 'Int_Ext')}
                />
              </Table.Cell>
              <Table.Cell>
                <Input
                  type="text"
                  value={row.Description}
                  onChange={(e) => handleChange(e, row.S_No, 'Description')}
                />
              </Table.Cell>
              <Table.Cell colSpan={2}>
                <Input
                  type="text"
                  value={row.Action_taken}
                  onChange={(e) => handleChange(e, row.S_No, 'Action_taken')}
                />
              </Table.Cell>
              
              <Table.Cell>
                <div className="ui buttons">
                {index === tableData.length - 1 ? (
                  <button className="ui positive button" onClick={()=>{ CreateCommentLoad(tableData[index]); handleAddRow();}}><Icon  className='plus'/></button>)
                  :<button className="ui red button" onClick={() => {updateCommentLoad(tableData[index]);handleRemoveRow(index);}}><Icon  className='trash'/></button>}
                </div> 
              </Table.Cell>
            </Table.Row>
          ))}
                        </TableBody>
                      </Table>
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow>
                <TableCell style={styles['pcr-report-value']}><Header>Note: </Header></TableCell>
                <TableCell colSpan={5}><Input type="text" placeholder="Please Enter Comments" style={{ width: '100%', margin: 0, padding: 0 }} value={note} onChange={(event) => setnote(event.target.value)}/> </TableCell>
                </TableRow>
              </TableBody>
          </Table>
      </div>
       <div style={{textAlign:'center'}}>
        <br/>
         <Button className='ui green button' onClick={Confirmation}>Save</Button>
        <Button className="ui button" onClick={goBack}>Cancel </Button>
            <br/>
        </div>
        <Modal open={open} onClose={() => setOpen(false)} onOpen={() => setOpen(true)} size={'fullscreen'}>
              <ModalHeader>
                <ModalDescription>
                {rowdata !== null && openPCRReport === true && 
                <PCRDownload rowdata={rowdata}/>}
                </ModalDescription>
              </ModalHeader>
            </Modal>
            <Modal open={confirmModelOpen} onClose={()=>SetconfirmModelOpen(false)} onOpen={()=>SetconfirmModelOpen(true)}  size={'mini'}>
                <ModalHeader>
                <ModalDescription>
                <div>
                <p>Are you sure you want to proceed with updating the FRR Report?</p>
                <Button className='ui green button' onClick={CreatePCRDetails}>OK</Button>
                <Button className="ui button" onClick={()=>SetconfirmModelOpen(false)}>Cancel </Button>
                </div>
                </ModalDescription>
                </ModalHeader>
            </Modal>
  </>
  )
}

export default PCRReport